export default "__VITE_ASSET__9b300ba1__"